module.exports = __webpack_public_path__ + "static/img/per1 (33).665b7d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_member/per1 (33).png
// module id = VoFn
// module chunks = 1